<template>
  <section>
    <SideLeft
      :status="leftSideStatus"
      :fName="filtersName"
      :fResourceOwner="filtersResourceOwner"
      :fAuthStatus="filtersAuthStatus"
      :fUseStatus="filtersUseStatus"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :fName="filtersName"
        :fResourceOwner="filtersResourceOwner"
        :fAuthStatus="filtersAuthStatus"
        :fUseStatus="filtersUseStatus"
        @add1688Auth="add1688Auth"
        @clearKey="clearKey"
      />
      <router-view
        v-if="isSysRights('Account1688.getAccountList')"
        :first_loading="firstLoading"
        :items="items"
        @changeStatus="changeStatus"
        @openDelConfirm="openDelConfirm"
        @auth="auth"
        @change1688Auth="change1688Auth"
        @openErrorLog="openErrorLog"
      ></router-view>
      <no-rights v-else></no-rights>
      <Pagination
        class="pd-x-20 pd-sm-x-30"
        v-if="!firstLoading"
        :cur="page"
        :all="totalPage"
        :path="'/1688/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      />
    </div>
    <ModalAdd1688
      :open="openModalAuth"
      :accountId="modalAuthId"
      :modiItem="modalModiItem"
      @modiAuthSuccess="modiAuthSuccess"
    />
    <ModalLog :log="errorLog" />
    <Confirm
      @del_index_i="delAccount"
      :modal_id="'auth1688Del'"
      :modal_title="$t('product.删除授权账号')"
      :modal_text="$t('product.确定要删除授权账号么？')"
      :del_index="delId"
      :type="0"
    />
    <Confirm
      @del_index_i="authAccount"
      :modal_id="'auth1688Again'"
      :modal_title="$t('product.重新授权账号')"
      :modal_text="$t('product.确定要重新授权账号么？')"
      :del_index="authId"
      :type="1"
    />
    <api-loading :show="loading"></api-loading>
  </section>
</template>

<script>
import { confirmComponent } from "@components/components.js"; //$t('product.删除确认')
import { pagination } from "@components/pagination.js"; //$t('product.分页')
import SideLeft from "./left-side.vue"; //$t('product.左边栏')
import Header from "./header.vue"; //$t('product.页面头部')
import ModalAdd1688 from "./modal-add-1688.vue"; //$t('product.新增1688授权')
import ModalLog from "./modal-log.vue"; //$t('product.错误日志弹层')

export default {
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //$t('product.左边栏')状态
      loading: false,
      firstLoading: true,
      pageSizeSelect: [10, 20, 50],
      page: this.$route.params.page ? this.$route.params.page : 1,
      rowsPerPage: parseInt(store.get("1688-rowsPerPage"))
        ? parseInt(store.get("1688-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      items: [],
      filtersName: "",
      filtersResourceOwner: "",
      filtersAuthStatus: "",
      filtersUseStatus: "",
      openModalAuth: Symbol(),
      modalAuthId: "",
      modalModiItem: {},
      delId: "",
      authId: "",
      authName: "",
      errorLog: "",
    };
  },
  components: {
    SideLeft,
    Header,
    Pagination: pagination,
    ModalAdd1688,
    Confirm: confirmComponent,
    ModalLog,
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("1688-rowsPerPage", this.rowsPerPage);
    },
  },
  methods: {
    changeLeftSideStatus() {
      //改变$t('product.左边栏')状态
      this.leftSideStatus = !this.leftSideStatus;
      store.set("leftSideStatus", this.leftSideStatus);
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({ path: `${this.$route.meta.url}/1` });
      if (page == 1) {
        this.getList();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({ path: `${this.$route.meta.url}/${num}` });
      if (page == num) {
        this.getList();
      }
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getList();
    },
    getList() {
      if (!this.isSysRights("Account1688.getAccountList")) return;
      this.loading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        name: this.filtersName,
        resourceOwner: this.filtersResourceOwner,
        authStatus: this.filtersAuthStatus,
        status: this.filtersUseStatus,
      };
      $.api_call("api.Account1688.getAccountList", params, (r) => {
        this.loading = false;
        this.firstLoading = false;
        if (r.ErrorCode == "9999") {
          this.items = r.Data.Results;
          this.totalPage = r.Data.Pagination.totalPage;
          this.totalCount = r.Data.Pagination.totalCount;
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    getItem(id) {
      this.loading = true;
      $.api_call("api.Account1688.getAccountList", { id }, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          if (r.Data.Results.length == 0) return;
          this.items.forEach((e, i) => {
            if (e.id == r.Data.Results[0].id) {
              this.items.splice(i, 1, r.Data.Results[0]);
            }
          });
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    add1688Auth() {
      this.openModalAuth = Symbol();
      this.modalAuthId = "";
      $("#modalAdd1688").modal("show");
    },
    changeStatus(id) {
      this.loading = true;
      $.api_call("api.Account1688.changeStatus", { accountId: id }, (r) => {
        if (r.ErrorCode == "9999") {
          ShowTip(this.$t("product.状态改变成功"), "success");
          this.getItem(id);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    openDelConfirm(id) {
      this.delId = id;
      $("#auth1688Del").modal("show");
    },
    delAccount(id) {
      $("#auth1688Del").modal("hide");
      this.loading = true;
      $.api_call("api.Account1688.delAccount", { accountId: id }, (r) => {
        if (r.ErrorCode == "9999") {
          this.getList();
          ShowTip(this.$t("product.删除成功"), "success");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    auth(item) {
      (this.authId = item.id), (this.authName = item.name);
      $("#auth1688Again").modal("show");
    },
    authAccount(id) {
      let newW = window.open("/blank.html", "1688Auth", undefined, true);
      $.api_call(
        "api.Account1688.getAliCode",
        {
          name: this.authName,
          accountId: this.authId,
        },
        (r) => {
          if (r.ErrorCode == "9999") {
            localStorage.setItem("1688authKey", r.Data.Results.authKey);
            newW.location = r.Data.Results.url;
            window.addEventListener("storage", (e) => {
              if (e.key == "1688AuthOK") {
                this.loading = true;
                let t;
                t = setInterval(() => {
                  $.api_call(
                    "api.Account1688.getOauthStatus",
                    { authKey: r.Data.Results.authKey },
                    (r) => {
                      if (r.ErrorCode == "9999") {
                        if (r.Data.Results.status == 1) {
                          clearInterval(t);
                          $("#auth1688Again").modal("hide");
                          this.getItem(id);
                          $.gritter.add({
                            text: this.$t(
                              "product.授权成功！系统开始为您同步最近2周的1688采购单。稍后您可以在“采购管理->其他平台采购单管理”查看您的采购单。"
                            ),
                            sticky: false,
                            time: 900000,
                            speed: 200,
                            class_name: "gritter_success gritter-center",
                          });
                        } else {
                          if (r.Data.Results.message) {
                            clearInterval(t);
                            $("#auth1688Again").modal("hide");
                            this.loading = false;
                            ShowTip(r.Data.Results.message, "danger");
                          }
                        }
                      } else {
                        if (r.ErrorCode == "1002") {
                          userFailure(this);
                        } else {
                          ShowTip(r.Message, "danger");
                        }
                      }
                    }
                  );
                }, 3000);
              }
            });
          } else {
            newW.close();
            this.loading = false;
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    change1688Auth(item) {
      this.modalModiItem = item;
      this.modalAuthId = item.id;
      this.openModalAuth = Symbol();
      $("#modalAdd1688").modal("show");
    },
    modiAuthSuccess(id) {
      if (id) {
        this.getItem(id);
        ShowTip(this.$t("product.修改成功"), "success");
        $("#modalAdd1688").modal("hide");
        localStorage.setItem("create1688", moment().unix());
      } else {
        this.getList();
        $("#modalAdd1688").modal("hide");
        $.gritter.add({
          text: this.$t(
            "product.授权成功！系统开始为您同步最近2周的1688采购单。稍后您可以在“采购管理->1688采购单管理”查看您的采购单。"
          ),
          sticky: false,
          time: 900000,
          speed: 200,
          class_name: "gritter_success gritter-center",
        });
      }
    },
    filtrate(name, resourceOwner, authStatus, useStatus) {
      this.filtersName = name;
      this.filtersResourceOwner = resourceOwner;
      this.filtersAuthStatus = authStatus;
      this.filtersUseStatus = useStatus;
      this.toPage(1);
    },
    clearKey(type) {
      switch (type) {
        case "name":
          this.filtersName = "";
          break;
        case "resourceOwner":
          this.filtersResourceOwner = "";
          break;
        case "authStatus":
          this.filtersAuthStatus = "";
          break;
        case "status":
          this.filtersUseStatus = "";
          break;
      }
      this.toPage(1);
    },
    openErrorLog(errorLog) {
      this.errorLog = errorLog;
      $("#modalErrorLog").modal("show");
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.getList();
    let id = this.$route.params.id;
    if (id) {
      this.add1688Auth();
    }
  },
};
</script>